/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mHeadImg.vue?vue&type=template&id=2de2f5d3&scoped=true"
import script from "./mHeadImg.vue?vue&type=script&lang=js"
export * from "./mHeadImg.vue?vue&type=script&lang=js"
import style0 from "./mHeadImg.vue?vue&type=style&index=0&id=2de2f5d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de2f5d3",
  null
  
)

export default component.exports